import c from "./isUpSellProductOutStock.mjs";
function o(t) {
  return !t || t.length === 0 || t.every((e) => e.products.length === 0) ? !1 : t.every(
    (e) => e.products.every(
      ({ stockDetails: r }) => c(r)
    )
  );
}
export {
  o as default
};
